import React from 'react';
import { useCookies } from 'react-cookie';
import { Helmet } from "react-helmet";




// LOCAL COMPONENTS
import Branding from '../OBJECTS/branding.jsx';
import Menu from '../OBJECTS/menu.jsx';
import AirdropClaim from '../OBJECTS/airdropClaim.jsx';
import AmazingAirdrop from '../OBJECTS/amazingAirdrop.jsx';
import CountdownPopUp from '../OBJECTS/countdownPopUp.jsx';
import StartShoppingPopUp from '../OBJECTS/startShoppingPopUp.jsx';


// STYLES
import '../../STYLES/fonts.css';
import '../../STYLES/branding.css';
import '../../STYLES/common.css';
import '../../STYLES/containers.css';
import '../../STYLES/menuItems.css';
import '../../STYLES/domainViewer.css';
import '../../STYLES/searchBar.css';
import '../../STYLES/warnings.css';
import '../../STYLES/overlays.css';
import '../../STYLES/domainGrid.css';
import '../../STYLES/shoppingCart.css';
import '../../STYLES/explore.css';
import '../../STYLES/popOvers.css';

import { 
	goToDiscord
} from '../OBJECTS/linkManagement.jsx';


import {ethers} from 'ethers';

import {checkTokensOnEvm} from '../OBJECTS/evmQueryChain.jsx';

// import {getProperNoun,getNoun, randomShortWord} from '../SCRIPTS/pricing.js'

import {getTokenInfo} from '../../services/api';
import {globalCacheVersion, getCacheVersion} from '../OBJECTS/cacheControl.jsx';
import {useDappParams, useMultiChainWallet} from '../../hooks';

let allEmojis = ["😀","😁","😂","😃","😄","😅","😆","😇","😈","👿","😉","😊","☺️","😋","😌","😍","😎","😏","😐","😑","😒","😓","😔","😕","😖","😗","😘","😙","😚","😛","😜","😝","😞","😟","😠","😡","😢","😣","😤","😥","😦","😧","😨","😩","😪","😫","😬","😭","😮","😯","😰","😱","😲","😳","😴","😵","😶","😷","😸","😹","😺","😻","😼","😽","😾","😿","🙀","👣","👤","👥","👶","👶🏻","👶🏼","👶🏽","👶🏾","👶🏿","👦","👦🏻","👦🏼","👦🏽","👦🏾","👦🏿","👧","👧🏻","👧🏼","👧🏽","👧🏾","👧🏿","👨","👨🏻","👨🏼","👨🏽","👨🏾","👨🏿","👩","👩🏻","👩🏼","👩🏽","👩🏾","👩🏿","👪","👨‍👩‍👧","👨‍👩‍👧‍👦","👨‍👩‍👦‍👦","👨‍👩‍👧‍👧","👩‍👩‍👦","👩‍👩‍👧","👩‍👩‍👧‍👦","👩‍👩‍👦‍👦","👩‍👩‍👧‍👧","👨‍👨‍👦","👨‍👨‍👧","👨‍👨‍👧‍👦","👨‍👨‍👦‍👦","👨‍👨‍👧‍👧","👫","👬","👭","👯","👰","👰🏻","👰🏼","👰🏽","👰🏾","👰🏿","👱","👱🏻","👱🏼","👱🏽","👱🏾","👱🏿","👲","👲🏻","👲🏼","👲🏽","👲🏾","👲🏿","👳","👳🏻","👳🏼","👳🏽","👳🏾","👳🏿","👴","👴🏻","👴🏼","👴🏽","👴🏾","👴🏿","👵","👵🏻","👵🏼","👵🏽","👵🏾","👵🏿","👮","👮🏻","👮🏼","👮🏽","👮🏾","👮🏿","👷","👷🏻","👷🏼","👷🏽","👷🏾","👷🏿","👸","👸🏻","👸🏼","👸🏽","👸🏾","👸🏿","💂","💂🏻","💂🏼","💂🏽","💂🏾","💂🏿","👼","👼🏻","👼🏼","👼🏽","👼🏾","👼🏿","🎅","🎅🏻","🎅🏼","🎅🏽","🎅🏾","🎅🏿","👻","👹","👺","💩","💀","👽","👾","🙇","🙇🏻","🙇🏼","🙇🏽","🙇🏾","🙇🏿","💁","💁🏻","💁🏼","💁🏽","💁🏾","💁🏿","🙅","🙅🏻","🙅🏼","🙅🏽","🙅🏾","🙅🏿","🙆","🙆🏻","🙆🏼","🙆🏽","🙆🏾","🙆🏿","🙋","🙋🏻","🙋🏼","🙋🏽","🙋🏾","🙋🏿","🙎","🙎🏻","🙎🏼","🙎🏽","🙎🏾","🙎🏿","🙍","🙍🏻","🙍🏼","🙍🏽","🙍🏾","🙍🏿","💆","💆🏻","💆🏼","💆🏽","💆🏾","💆🏿","💇","💇🏻","💇🏼","💇🏽","💇🏾","💇🏿","💑","👩‍❤️‍👩","👨‍❤️‍👨","💏","👩‍❤️‍💋‍👩","👨‍❤️‍💋‍👨","🙌","🙌🏻","🙌🏼","🙌🏽","🙌🏾","🙌🏿","👏","👏🏻","👏🏼","👏🏽","👏🏾","👏🏿","👂","👂🏻","👂🏼","👂🏽","👂🏾","👂🏿","👀","👃","👃🏻","👃🏼","👃🏽","👃🏾","👃🏿","👄","💋","👅","💅","💅🏻","💅🏼","💅🏽","💅🏾","💅🏿","👋","👋🏻","👋🏼","👋🏽","👋🏾","👋🏿","👍","👍🏻","👍🏼","👍🏽","👍🏾","👍🏿","👎","👎🏻","👎🏼","👎🏽","👎🏾","👎🏿","☝","☝🏻","☝🏼","☝🏽","☝🏾","☝🏿","👆","👆🏻","👆🏼","👆🏽","👆🏾","👆🏿","👇","👇🏻","👇🏼","👇🏽","👇🏾","👇🏿","👈","👈🏻","👈🏼","👈🏽","👈🏾","👈🏿","👉","👉🏻","👉🏼","👉🏽","👉🏾","👉🏿","👌","👌🏻","👌🏼","👌🏽","👌🏾","👌🏿","✌","✌🏻","✌🏼","✌🏽","✌🏾","✌🏿","👊","👊🏻","👊🏼","👊🏽","👊🏾","👊🏿","✊","✊🏻","✊🏼","✊🏽","✊🏾","✊🏿","✋","✋🏻","✋🏼","✋🏽","✋🏾","✋🏿","💪","💪🏻","💪🏼","💪🏽","💪🏾","💪🏿","👐","👐🏻","👐🏼","👐🏽","👐🏾","👐🏿","🙏","🙏🏻","🙏🏼","🙏🏽","🙏🏾","🙏🏿","🌱","🌲","🌳","🌴","🌵","🌷","🌸","🌹","🌺","🌻","🌼","💐","🌾","🌿","🍀","🍁","🍂","🍃","🍄","🌰","🐀","🐁","🐭","🐹","🐂","🐃","🐄","🐮","🐅","🐆","🐯","🐇","🐰","🐈","🐱","🐎","🐴","🐏","🐑","🐐","🐓","🐔","🐤","🐣","🐥","🐦","🐧","🐘","🐪","🐫","🐗","🐖","🐷","🐽","🐕","🐩","🐶","🐺","🐻","🐨","🐼","🐵","🙈","🙉","🙊","🐒","🐉","🐲","🐊","🐍","🐢","🐸","🐋","🐳","🐬","🐙","🐟","🐠","🐡","🐚","🐌","🐛","🐜","🐝","🐞","🐾","⚡️","🔥","🌙","☀️","⛅️","☁️","💧","💦","☔️","💨","❄️","🌟","⭐️","🌠","🌄","🌅","🌈","🌊","🌋","🌌","🗻","🗾","🌐","🌍","🌎","🌏","🌑","🌒","🌓","🌔","🌕","🌖","🌗","🌘","🌚","🌝","🌛","🌜","🌞","🍅","🍆","🌽","🍠","🍇","🍈","🍉","🍊","🍋","🍌","🍍","🍎","🍏","🍐","🍑","🍒","🍓","🍔","🍕","🍖","🍗","🍘","🍙","🍚","🍛","🍜","🍝","🍞","🍟","🍡","🍢","🍣","🍤","🍥","🍦","🍧","🍨","🍩","🍪","🍫","🍬","🍭","🍮","🍯","🍰","🍱","🍲","🍳","🍴","🍵","☕️","🍶","🍷","🍸","🍹","🍺","🍻","🍼","🎀","🎁","🎂","🎃","🎄","🎋","🎍","🎑","🎆","🎇","🎉","🎊","🎈","💫","✨","💥","🎓","👑","🎎","🎏","🎐","🎌","🏮","💍","❤️","💔","💌","💕","💞","💓","💗","💖","💘","💝","💟","💜","💛","💚","💙","🏃","🏃🏻","🏃🏼","🏃🏽","🏃🏾","🏃🏿","🚶","🚶🏻","🚶🏼","🚶🏽","🚶🏾","🚶🏿","💃","💃🏻","💃🏼","💃🏽","💃🏾","💃🏿","🚣","🚣🏻","🚣🏼","🚣🏽","🚣🏾","🚣🏿","🏊","🏊🏻","🏊🏼","🏊🏽","🏊🏾","🏊🏿","🏄","🏄🏻","🏄🏼","🏄🏽","🏄🏾","🏄🏿","🛀","🛀🏻","🛀🏼","🛀🏽","🛀🏾","🛀🏿","🏂","🎿","⛄️","🚴","🚴🏻","🚴🏼","🚴🏽","🚴🏾","🚴🏿","🚵","🚵🏻","🚵🏼","🚵🏽","🚵🏾","🚵🏿","🏇","🏇🏻","🏇🏼","🏇🏽","🏇🏾","🏇🏿","⛺️","🎣","⚽️","🏀","🏈","⚾️","🎾","🏉","⛳️","🏆","🎽","🏁","🎹","🎸","🎻","🎷","🎺","🎵","🎶","🎼","🎧","🎤","🎭","🎫","🎩","🎪","🎬","🎨","🎯","🎱","🎳","🎰","🎲","🎮","🎴","🃏","🀄️","🎠","🎡","🎢","🚃","🚞","🚂","🚋","🚝","🚄","🚅","🚆","🚇","🚈","🚉","🚊","🚌","🚍","🚎","🚐","🚑","🚒","🚓","🚔","🚨","🚕","🚖","🚗","🚘","🚙","🚚","🚛","🚜","🚲","🚏","⛽️","🚧","🚦","🚥","🚀","🚁","✈️","💺","⚓️","🚢","🚤","⛵️","🚡","🚠","🚟","🛂","🛃","🛄","🛅","💴","💶","💷","💵","🗽","🗿","🌁","🗼","⛲️","🏰","🏯","🌇","🌆","🌃","🌉","🏠","🏡","🏢","🏬","🏭","🏣","🏤","🏥","🏦","🏨","🏩","💒","⛪️","🏪","🏫","🇦🇺","🇦🇹","🇧🇪","🇧🇷","🇨🇦","🇨🇱","🇨🇳","🇨🇴","🇩🇰","🇫🇮","🇫🇷","🇩🇪","🇭🇰","🇮🇳","🇮🇩","🇮🇪","🇮🇱","🇮🇹","🇯🇵","🇰🇷","🇲🇴","🇲🇾","🇲🇽","🇳🇱","🇳🇿","🇳🇴","🇵🇭","🇵🇱","🇵🇹","🇵🇷","🇷🇺","🇸🇦","🇸🇬","🇿🇦","🇪🇸","🇸🇪","🇨🇭","🇹🇷","🇬🇧","🇺🇸","🇦🇪","🇻🇳","⌚️","📱","📲","💻","⏰","⏳","⌛️","📷","📹","🎥","📺","📻","📟","📞","☎️","📠","💽","💾","💿","📀","📼","🔋","🔌","💡","🔦","📡","💳","💸","💰","💎","🌂","👝","👛","👜","💼","🎒","💄","👓","👒","👡","👠","👢","👞","👟","👙","👗","👘","👚","👕","👔","👖","🚪","🚿","🛁","🚽","💈","💉","💊","🔬","🔭","🔮","🔧","🔪","🔩","🔨","💣","🚬","🔫","🔖","📰","🔑","✉️","📩","📨","📧","📥","📤","📦","📯","📮","📪","📫","📬","📭","📄","📃","📑","📈","📉","📊","📅","📆","🔅","🔆","📜","📋","📖","📓","📔","📒","📕","📗","📘","📙","📚","📇","🔗","📎","📌","✂️","📐","📍","📏","🚩","📁","📂","✒️","✏️","📝","🔏","🔐","🔒","🔓","📣","📢","🔈","🔉","🔊","🔇","💤","🔔","🔕","💭","💬","🚸","🔍","🔎","🚫","⛔️","📛","🚷","🚯","🚳","🚱","📵","🔞","🉑","🉐","💮","㊙️","㊗️","🈴","🈵","🈲","🈶","🈚️","🈸","🈺","🈷","🈹","🈳","🈂","🈁","🈯️","💹","❇️","✳️","❎","✅","✴️","📳","📴","🆚","🅰","🅱","🆎","🆑","🅾","🆘","🆔","🅿️","🚾","🆒","🆓","🆕","🆖","🆗","🆙","🏧","♈️","♉️","♊️","♋️","♌️","♍️","♎️","♏️","♐️","♑️","♒️","♓️","🚻","🚹","🚺","🚼","♿️","🚰","🚭","🚮","▶️","◀️","🔼","🔽","⏩","⏪","⏫","⏬","➡️","⬅️","⬆️","⬇️","↗️","↘️","↙️","↖️","↕️","↔️","🔄","↪️","↩️","⤴️","⤵️","🔀","🔁","🔂","#⃣","0⃣","1⃣","2⃣","3⃣","4⃣","5⃣","6⃣","7⃣","8⃣","9⃣","🔟","🔢","🔤","🔡","🔠","ℹ️","📶","🎦","🔣","➕","➖","〰","➗","✖️","✔️","🔃","™","©","®","💱","💲","➰","➿","〽️","❗️","❓","❕","❔","‼️","⁉️","❌","⭕️","💯","🔚","🔙","🔛","🔝","🔜","🌀","Ⓜ️","⛎","🔯","🔰","🔱","⚠️","♨️","♻️","💢","💠","♠️","♣️","♥️","♦️","☑️","⚪️","⚫️","🔘","🔴","🔵","🔺","🔻","🔸","🔹","🔶","🔷","▪️","▫️","⬛️","⬜️","◼️","◻️","◾️","◽️","🔲","🔳","🕐","🕑","🕒","🕓","🕔","🕕","🕖","🕗","🕘","🕙","🕚","🕛","🕜","🕝","🕞","🕟","🕠","🕡","🕢","🕣","🕤","🕥","🕦","🕧"]



const ExploreDomainsPage = () => {

	const {isSolanaConnected, chainId, account, network, solana: {connection}, connected, connecting} = useMultiChainWallet();
	const {contracts,collectionNftMints} = useDappParams();

	React.useEffect(() => {
		window.checkTokensOnEvm = async function(tokenStrings) {
			let x = await checkTokensOnEvm(contracts,account,tokenStrings);
			return x;
		}
	});

	function showAirdropDetails() {
		window.makeErrorMessage('Free Airdrop Details',`Name that can be minted for free include any combination of letters, numbers, and / or emojis that is six characters or more and excludes proper nouns and dictionary words.<br><br>Examples: 0xrobert, suzanne😃, homie98`);
		
	}

	function search() {
		let searchText = document.querySelector('#searchInput');
		if (searchText.value != '') {
			window.location = `/searchResults?id=${searchText.value}`
		}
	}

	function getTokeHash(tokenString) {
		return ethers.BigNumber.from(ethers.utils.solidityKeccak256(['string'], [tokenString])).toString();
	}

	// Free with airdrop, 2 Emojis, 3 Chars, 4 Chars, 5 Chars, Proper Nouns

	const [gettingCategories, setGettingCategories] = React.useState('');

	// function randomExtra() {
	// 	if (Math.random() < 0.3) {
	// 		return allEmojis[Math.floor(Math.random() * allEmojis.length)];
	// 	}
	// 	if (Math.random() < 0.5) {
	// 		return randomShortWord(1,3)[0]
	// 	}
	// 	return randomShortWord(1,4)[0]
	// }

	// function randomEmojis(count,num) {
	// 	let ems = [];
	// 	for (let i = 0; i < count; i++) {
	// 		let temp = '';
	// 		for (let x = 0; x < num; x++) {
	// 			temp += allEmojis[Math.floor(Math.random() * allEmojis.length)];
	// 		}
	// 		ems.push(temp)
	// 	}
	// 	return ems
	// }

	// function randomAlphaNumericals(count,num) {
	// 	let vals = [];
	// 	for (let i = 0; i < count; i++) {
	// 		let temp = '';
	// 		for (let x = 0; x < num; x++) {
	// 			let choices = 'abcdefghijklmnopqrstuvwxyz0123456789';
	// 			temp += choices.charAt(Math.floor(Math.random() * choices.length));
	// 		}
	// 		vals.push(temp)
	// 	}
	// 	return vals;
	// }

	// function reduceArray(list,taken,count) {

	// 	let preSelected = [];
	// 	let nonSelected = [];

	// 	list.forEach(l => {
	// 		if (taken.includes(l)) {
	// 			nonSelected.push(l)
	// 		}
	// 		else {
	// 			preSelected.push(l)
	// 		}
	// 	})

	// 	if (preSelected.length == count) {
	// 		return preSelected
	// 	}
	// 	else if (preSelected.length > count) {
	// 		preSelected.length -= (preSelected.length - count)
	// 		return preSelected
	// 	}
	// 	else {
	// 		nonSelected.length -= nonSelected.length - (count - preSelected.length);
	// 		nonSelected.forEach(l => {
	// 			preSelected.push(l);
	// 		});
	// 		return preSelected;
	// 	}

	// }

	// function shuffleArray(array) {
	//     for (let i = array.length - 1; i > 0; i--) {
	//         const j = Math.floor(Math.random() * (i + 1));
	//         [array[i], array[j]] = [array[j], array[i]];
	//     }
	// }

	// async function getCategories() {
	// 	if (!gettingCategories) {

	// 		setGettingCategories(true);


	// 		let properNouns = getProperNoun(10);
	// 		let nouns = getNoun(10);

	// 		let standardWords = [];
	// 		getProperNoun(5).forEach(w => {
	// 			standardWords.push(w + randomExtra())
	// 		})

	// 		getNoun(5).forEach(w => {
	// 			standardWords.push(w + randomExtra())
	// 		})

	// 		let tempStandard = [];
	// 		standardWords.forEach(word => {
	// 			if (word.length > 16) {
	// 				if (word && word.splice) {
	// 					word.splice(16,word.length-16);
	// 				}
	// 			}
	// 			tempStandard.push(word)
	// 		})
	// 		standardWords = tempStandard;


	// 		let twoEmojis = randomEmojis(10,2);

	// 		let threeChars = randomShortWord(10,3);
	// 		let fourChars = randomShortWord(5,4);
	// 		let fiveChars = randomShortWord(5,5);
	// 		let rareWords = fourChars;
	// 		fiveChars.forEach(w => {
	// 			rareWords.push(w);
	// 		})


	// 		let superList = [standardWords,twoEmojis,threeChars,properNouns,nouns,rareWords];

	// 		let categoryNames = [
	// 			'Free With Airdrop',
	// 			'Two Emojis',
	// 			'Super Short Words',
	// 			'Proper Nouns',
	// 			'English Words',
	// 			'Rare Words',
	// 		]
	// 		let categoryColors = [
	// 			'#00ffa2',
	// 			'#ffe659',
	// 			'#03e1ff',
	// 			'#d267ff',
	// 			'#ff7373',
	// 			'#00ffa2',
	// 		]

	// 		let squasedList = [];
	// 		superList.forEach(l => {
	// 			shuffleArray(l)
	// 			l.forEach(item => {
	// 				squasedList.push(getTokeHash(item));
	// 			})
	// 		})


	// 		let availability = await getTokenInfo(squasedList);
	// 		let taken = [];

	// 		for (let key in availability) {
	// 			taken.push(availability[key]);
	// 		}

	// 		let finalLists = [];

	// 		let counter = 0;
	// 		superList.forEach(l => {
	// 			let arr = reduceArray(l,taken,4);
	// 			// console.log(arr)
	// 			finalLists.push({
	// 				'category': categoryNames[counter],
	// 				'color': categoryColors[counter],
	// 				'items': arr
	// 			});
	// 			counter++;
	// 		});

	// 		window.loadExploreExamples(finalLists,taken)


	// 		// console.log(finalLists);

	// 		// console.log('here')
	// 		// let p = getProperNoun(10);

	// 		// let queriable = [];
	// 		// p.forEach(v => {
	// 		// 	queriable.push(getTokeHash(v));
	// 		// })
	// 		// queriable.push(getTokeHash('a'));


	// 		// let x = await getTokenInfo(queriable)
	// 		// console.log(p,x);
	// 	}
		
	// }

	// React.useEffect(() => {
	// 	//getCategories();
	// });



	// -- AIRDROP

	const [displayingAirdrop, setDisplayingAirdrop] = React.useState('');

	let location = window.location;
	let params = {};


	if (location.search) {

		let p = decodeURIComponent(location.search)

    	var parts = p.substring(1).split('&');

	    for (var i = 0; i < parts.length; i++) {
	        var nv = parts[i].split('=');
	        if (!nv[0]) continue;
	        params[nv[0]] = nv[1] || true;
	    }
	}

	function checkCodeUsed(secretCode) {

		let usedCodes = window.getUsedCodes();
		for (let k in usedCodes) {
			let v = usedCodes[k]
			if (secretCode == v) {
				return true
			}
		}

		return false;
	}

	function handleAirdropLink() {



		setDisplayingAirdrop(true);

		//let from = params['from'];
		let code = params['code'];
		let type = params['type'];
		let ticketTypes = ['twitter','discord','partner'];
		let ticketIndex = ticketTypes.indexOf(type);

		if (checkCodeUsed(code)) {
			return;
		}

		// console.log(ticketIndex,from,code)

		if (ticketIndex >= 0) {
			if (code) {


				let inputRefs = document.querySelectorAll('.innerInputAirdrop');
				inputRefs[3].value = code;
				inputRefs[3].style.color = '#00ffa2';

				document.querySelectorAll('.inputAirdropStyle')[3].style.border = '1px solid #00ffa2'
				document.querySelectorAll('.checkMark')[3].style.fill = '#00ffa2'
				document.querySelectorAll('.airdropInputLine')[3].style.backgroundColor = '#00ffa2'
				document.querySelectorAll('.checkPath')[3].setAttribute('d', "M 42.875 8.625 C 42.84375 8.632813 42.8125 8.644531 42.78125 8.65625 C 42.519531 8.722656 42.292969 8.890625 42.15625 9.125 L 21.71875 40.8125 L 7.65625 28.125 C 7.410156 27.8125 7 27.675781 6.613281 27.777344 C 6.226563 27.878906 5.941406 28.203125 5.882813 28.597656 C 5.824219 28.992188 6.003906 29.382813 6.34375 29.59375 L 21.25 43.09375 C 21.46875 43.285156 21.761719 43.371094 22.050781 43.328125 C 22.339844 43.285156 22.59375 43.121094 22.75 42.875 L 43.84375 10.1875 C 44.074219 9.859375 44.085938 9.425781 43.875 9.085938 C 43.664063 8.746094 43.269531 8.566406 42.875 8.625 Z");
				
				//window.startConfetti();


				let conferttiInterval = setInterval(function() {
					if (window.startConfetti) {
						clearInterval(conferttiInterval);
						window.startConfetti();
					}
				},100);
				

				
				document.getElementById("confetti-canvas").style = "display:block; pointer-events:none; top: 0px; left: 0px; position: absolute;"

				document.querySelector('#amazingAirdropPopUp').style.display = 'block';



			}
		}

	}

	// React.useEffect(() => {

	// 	if (params && !displayingAirdrop) {
	// 		handleAirdropLink();
	// 	}

	// });



	// function startAirdrop() {
	// 	// window.startConfetti()
	// 	document.querySelector('#airdropPopUp').style.display = 'block';
	// 	//document.querySelector('#amazingAirdropPopUp').style.display = 'block';
	// 	// window.startConfetti()

	// 	// test-anyside.web.app/explore?from=mintable&code=anysidetwitter123&type=twitter
	// }

	return (
		<div>
			<div class="fullMainPage whiteText">

				<div class="airdropStatus whiteText bottomLightBorder clickableItem" id="airdropStatus" onClick={goToDiscord}>
					Join Our Discord
				</div>

				<div class="titleContainer bottomLightBorder">

					<img src="https://i.imgur.com/Z67MgrMl.png" class="titleBackground"/>

					<div class="titleTextVeritcal">
						<b class="largeFontFlex">Register <a class="blueGreenGradientText">.Any Names</a></b><br/>
						<a class="">Explore Available Domain Names</a><br/>

						
					</div>

					<div class="exploreSearchContainer whiteBackground standardCurve blackBorder outerGlow" id="searchContainer">
						<img src="../ICONS/SEARCH/searchBlack.png" class="menuItemIcon" id="searchIcon"/>
						<div class="lightLine blackBackground" id="lightLine"></div>
						<input type="text" class="searchInput" id="searchInput" placeholder="Search domains"/>
					</div><div class="searchButton standardCurve blackBorder gradientBackground blackText greenGlow subtleClickable" id="searchButton" onClick={search}>Search</div>

					<div class="fullWidthContainer">
					<center>
						<div class="airdropExplanation tinyFont">What's included in the Airdrop?<br/>Domains marked Free. <u class="clickableText" onClick={showAirdropDetails}>Get Details.</u></div>
					</center>
					</div>
				</div>

				
				
				

				<div class="interstitialText">
					<b class="mediumFont">Not Sure What To Register?</b><br/>
					Here are some examples.
				</div>

				<div class="globalShader" id="globalShader">
					
				</div>
				

				<div class="gridContainer" id="gridContainer">

				</div>

				<div class="mainPageShader" id="mainPageShader">
					<div class="clickOutOfShader" id="clickOutOfShader"></div>
					<div class="searchPreviewContainer charcolBackground lightBorder standardCurve" id="searchPreviewContainer">
					</div>
				</div>
			</div>


			<Menu/>
      		<Branding/>


      		<AirdropClaim/>
			<AmazingAirdrop/>
			<CountdownPopUp/>
			<StartShoppingPopUp/>
			


			<Helmet>

			
			
			


				
				{/*<script src="../SCRIPTS/errorPopup.js"></script>*/}
				{/*<script src="../DATA/wordMap.js"></script>
				<script src="../SCRIPTS/utils.js"></script>*/}
				<script src={`../SCRIPTS/explore.js?v=${getCacheVersion('explore')}&g=${globalCacheVersion}`}></script>
				<script src={`../SCRIPTS/searchSuggestion.js?v=${getCacheVersion('searchSuggestion')}&g=${globalCacheVersion}`}></script>
				{/*<script src="../SCRIPTS/cartLogic.js"></script>*/}
				<script src={`../SCRIPTS/popOvers.js?v=${getCacheVersion('popOvers')}&g=${globalCacheVersion}`}></script>
				<script src="../SCRIPTS/confetti.js"></script>
				{/*<script src="../SCRIPTS/pricing.js"></script>*/}
			</Helmet>


		</div>
	)
}



export default ExploreDomainsPage;